import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';

const API_URL = '/api/document-category';

export const useFetchDocumentCategories = (token) => {
    return useQuery({
        queryKey: ['documentCategories', token],
        queryFn: async () => {
            const response = await axios.get(API_URL, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        },
        enabled: !!token,
        staleTime: 5 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};

export const useCreateDocumentCategory = (token) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data) => {
            const response = await axios.post(API_URL, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['documentCategories', token]);
        },
    });
};

export const useUpdateDocumentCategory = (token) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ selectedId, document_category }) => {
            const response = await axios.put(`${API_URL}/${selectedId}`, { document_category }, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['documentCategories', token]);
        },
    });
};

export const useDeleteDocumentCategory = (token) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id) => {
            const response = await axios.delete(`${API_URL}/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['documentCategories', token]);
        },
    });
};